import React from 'react';

function AthleticsHotspot(props) {
  const { onClick, style, className } = props;
  return (
    <div onClick={onClick} style={{cursor:'pointer', ...style}} className={className}>
      <img src={require('./AthleticsHotspot.svg').default} alt="" style={{width:'100%',height:'auto'}} />
    </div>
  );
}

export default AthleticsHotspot;
